import { connect } from "react-redux";
import { saveFile } from "../store/actions/files"
import UploadForm from '../components/upload/Form';

function mapStateToProps(state, ownProps) {
  return {
    errors: state.errors,
    user: state.currentUser.user,
    ...ownProps
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addFile: (fileMeta) => {
      return dispatch(saveFile(fileMeta));
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(UploadForm)



// WEBPACK FOOTER //
// ./src/containers/Upload.js